import { render, staticRenderFns } from "./PendencyDetailsChecklistValue.vue?vue&type=template&id=2a529956"
import script from "./PendencyDetailsChecklistValue.vue?vue&type=script&lang=js"
export * from "./PendencyDetailsChecklistValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports